/**
 *
 * UI Intents
 *
 * */

import {
    VanillaReaderEventBus
} from "../VanillaReaderEventBus/VanillaReaderEventBus";
import {VanillaReader} from "./VanillaReader";
import {
    IVanillaReaderAppEvent_APP_WINDOW_RESIZED,
} from "../VanillaReaderEventBus/IVanillaReaderAppEventTypeMap";

export class VanillaReaderUiIntentController {

    constructor(private _vanillaReader: VanillaReader) {

            /*
            * All the following events are dispatched by the `VanillaReaderUI` component. You can basically see this as a list
            * of all the main features that are offered by the reading app.
            * */
            VanillaReaderEventBus.addEventListener("APP_WINDOW_RESIZED", this._uiEvent_appWindowResized);
            VanillaReaderEventBus.addEventListener("PUBLICATION_STORED_RESOURCES_DELETED", ()=>{});
    }
    private _uiEvent_appWindowResized = (_ev: CustomEvent<IVanillaReaderAppEvent_APP_WINDOW_RESIZED>) => {
        this._vanillaReader.vanillaReaderView?.refresh();
    };

}

